<div class="center-xy"
     [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden'}"
     *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light" data-testid="schedule-settings-control">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <zone-icon [name]="zones.selectedZone.description.styleIcon" [size]="45"></zone-icon>
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                {{ zones.getZoneName(zones.selectedZone) }}
            </p>
        </div>
        <div class="zone-control__content">
            <div class="schedule">
                <div class="schedule__top">
                    <div>
                        <input class="schedule__name--input font-18 font-bold"
                               type="text"
                               maxlength="40"
                               *ngIf="zoneSchedule.type == 'global'"
                               placeholder="{{ subtitle(1683) + ' ' + (zoneSchedule.schedule.index + 1)}}"
                               [(ngModel)]="zoneSchedule.name">
                        <p class="schedule__name font-18 font-bold"
                           *ngIf="zoneSchedule.type === 'local'">
                            {{ zoneSchedule.name }}
                        </p>
                    </div>
                    <div class="schedule__set-in-zone"
                         *ngIf="zoneSchedule.setInZones.length > 0">
                        <p class="schedule__set-in-name font-16 font-bold color-alarm">
                            {{ subtitle(1795) }}
                        </p>
                        <div class="schedule__set-in-elements">
                            <p class="schedule__set-in-name font-18 font-bold"
                               *ngFor="let zone of zoneSchedule.setInZones; let idx = index">
                                {{ zones.getZoneName(zone) + (idx === zoneSchedule.setInZones.length - 1 ? '' : ', ') }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="schedule__item schedule__item--first box-shadow"
                    data-testid="first-schedule">
                    <div class="schedule__week">
                        <div class="schedule__day cursor-pointer"
                             *ngFor="let day of zoneSchedule.schedule.p0Days; let idx = index"
                             [ngClass]="{ 'bg-style': day === '1',
                                'bg-default': day !== '1' }"
                             (click)="zoneSchedule.setDay(idx)">
                            <p class="color-light">{{ idx | shortDayName }}</p>
                        </div>
                    </div>
                    <div class="schedule__content">
                        <div class="schedule__set-temp">
                            <p class="schedule__temp-subtitle font-20 font-bold">
                                {{ subtitles.language === 'en' ? 'Setback temperature' : subtitle(760) }}
                            </p>
                            <p class="schedule__set-back-temp font-50 font-bold cursor-pointer"
                               data-testid="set-back-temp"
                               (click)="zoneSchedule.showHideSetTemp('first', zoneSchedule.schedule.p0SetbackTemp, 'show')">
                                {{ zoneSchedule.schedule.p0SetbackTemp | format:7 }}
                            </p>
                        </div>
                        <div class="interval">
                            <div class="interval__item"
                                 *ngFor="let interval of zoneSchedule.firstIntervals; let idx = index"
                                [attr.data-testid]="'interval-' + idx">
                                <div class="interval__time bg-settings bg-settings--zone cursor-pointer"
                                     (click)="zoneSchedule.setInterval('first', idx)"
                                     [ngClass]="{ 'border-error interval__time--error': interval.wrongInterval }">
                                    <div class="interval__time-start">
                                        <p class="interval__value font-19 font-bold">
                                            {{ interval.start | format:13 }}
                                        </p>
                                    </div>
                                    <p class="interval__value font-18 font-bold">
                                        -</p>
                                    <div class="interval__time-stop">
                                        <p class="interval__value font-19 font-bold">
                                            {{ interval.stop | format:13 }}
                                        </p>
                                    </div>
                                </div>
                                <div class="interval__temp bg-error cursor-pointer"
                                     (click)="zoneSchedule.setInterval('first', idx)">
                                    <p class="interval__value font-19 font-bold color-light">
                                        {{ interval.temp | format:7 }}
                                    </p>
                                </div>
                                <div class="interval__delete-item"
                                     [attr.data-testid]="'delete-interval-'+idx"
                                     (click)="zoneSchedule.deleteInterval('first', idx)"
                                     (mouseenter)="firstDeleteHover = idx;"
                                     (mouseleave)="firstDeleteHover = -1;">
                                    <img class="interval__delete-img cursor-pointer"
                                         [ngClass]="{ 'bg-cancel': firstDeleteHover === idx,
                                            'bg-default': firstDeleteHover !== idx }"
                                         ngSrc="/assets/img/zone_icons/delete_interval.svg"
                                         width="25" height="25" alt=""/>
                                </div>
                            </div>

                            <div class="interval__add"
                                 data-testid="add-interval"
                                 *ngIf="zoneSchedule.firstIntervals.length < 3">
                                <img class="interval__add-img cursor-pointer"
                                     (mouseenter)="firstAddHover = true"
                                     (mouseleave)="firstAddHover = false"
                                     [ngClass]="{ 'bg-style': firstAddHover,
                                        'bg-default': !firstAddHover }"
                                     (click)="zoneSchedule.addInterval('first')"
                                     ngSrc="/assets/img/zone_icons/add_interval.svg"
                                     width="30" height="30" alt=""/>
                            </div>

                            <div class="interval__set-temp bg-light"
                                 data-testid="set-temp-control"
                                 *ngIf="zoneSchedule.showFirstSetTemp">
                                <p class="interval__set-temp-value font-38 font-bold"
                                   data-testid="set-temp">
                                    {{ zoneSchedule.firstSetTemp | format:7 }}
                                </p>
                                <input class="interval__set-temp-range control__input-range cursor-pointer"
                                       data-testid="set-temp-slider"
                                       type="range"
                                       step="1"
                                       min="50"
                                       max="350"
                                       value="{{zoneSchedule.firstSetTemp}}"
                                       [(ngModel)]="zoneSchedule.firstSetTemp"/>
                                <p class="interval__set-temp-min">
                                    <span>{{ subtitle(1055) }}</span>
                                    <span>{{ 5 | format:6 }}</span>
                                </p>
                                <p class="interval__set-temp-max">
                                    <span>{{ subtitle(1937) }}</span>
                                    <span>{{ 35 | format:6 }}</span>
                                </p>
                                <div class="interval__set-temp-add cursor-pointer">
                                    <hold-wrapper
                                            data-testid="decrease-icon"
                                            (onAction)="zoneSchedule.firstSetTemp = zones.minusVal(zoneSchedule.firstSetTemp)">
                                        <img ngSrc="/assets/img/icons/minus.svg"
                                             width="40" height="40" alt=""/>
                                    </hold-wrapper>
                                </div>
                                <div class="interval__set-temp-add cursor-pointer">
                                    <hold-wrapper
                                            data-testid="increase-icon"
                                            (onAction)="zoneSchedule.firstSetTemp = zones.plusVal(zoneSchedule.firstSetTemp)">
                                        <img ngSrc="/assets/img/icons/plus.svg"
                                             width="40" height="40" alt=""/>
                                    </hold-wrapper>
                                </div>
                                <div class="interval__group-btn">
                                    <button class="interval__button bg-cancel bg-cancel__button cursor-pointer"
                                            (click)="zoneSchedule.showHideSetTemp('first', zoneSchedule.firstSetTemp, 'hide')">
                                        <img class="interval__button-img zone-control__button-back"
                                             data-testid="back-icon"
                                             ngSrc="/assets/img/zone_icons/back.svg"
                                             width="40" height="40" alt=""/>
                                    </button>
                                    <button class="interval__button bg-ok bg-ok--accept cursor-pointer"
                                            (click)="zoneSchedule.showHideSetTemp('first', zoneSchedule.firstSetTemp, 'save')">
                                        <img class="interval__button-img"
                                             data-testid="ok-icon"
                                             ngSrc="/assets/img/icons/ok.svg"
                                             width="40" height="40" alt=""/>
                                    </button>
                                </div>
                            </div>

                            <div class="change-interval bg-light"
                                 data-testid="change-interval-control"
                                 *ngIf="zoneSchedule.showFirstInterval">
                                <div class="change-interval__interval">
                                    <div class="change-interval__start-hour change-interval__item">
                                        <div class="change-interval__arrow-up cursor-pointer">
                                            <hold-wrapper
                                                    data-testid="start-hour-up"
                                                    (onAction)="zoneSchedule.firstInterval.startHour = zoneSchedule.changeHour(zoneSchedule.firstInterval.startHour, 1)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_up.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                        <div class="change-interval__value font-bold font-18 bg-settings bg-settings--zone">
                                            {{ zoneSchedule.firstInterval.startHour }}
                                        </div>
                                        <div class="change-interval__arrow-down cursor-pointer">
                                            <hold-wrapper
                                                    data-testid="start-hour-down"
                                                    (onAction)="zoneSchedule.firstInterval.startHour = zoneSchedule.changeHour(zoneSchedule.firstInterval.startHour, -1)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_down.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                    </div>
                                    <p class="font-bold font-20">:</p>
                                    <div class="change-interval__start-minute change-interval__item">
                                        <div class="change-interval__arrow-up cursor-pointer"
                                             *ngIf="zoneSchedule.firstInterval.startHour !== '24'">
                                            <hold-wrapper
                                                    data-testid="start-minute-up"
                                                    (onAction)="zoneSchedule.firstInterval.startMinute = zoneSchedule.changeMinute(zoneSchedule.firstInterval.startMinute, 15)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_up.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                        <div class="change-interval__value font-bold font-18 bg-settings bg-settings--zone">
                                            {{ zoneSchedule.firstInterval.startMinute }}
                                        </div>
                                        <div class="change-interval__arrow-down cursor-pointer"
                                             *ngIf="zoneSchedule.firstInterval.startHour !== '24'">
                                            <hold-wrapper
                                                    data-testid="start-minute-down"
                                                    (onAction)="zoneSchedule.firstInterval.startMinute = zoneSchedule.changeMinute(zoneSchedule.firstInterval.startMinute, -15)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_down.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                    </div>

                                    <p class="font-bold font-20">-</p>
                                    <div class="change-interval__stop-hour change-interval__item">
                                        <div class="change-interval__arrow-up cursor-pointer">
                                            <hold-wrapper
                                                    data-testid="stop-hour-up"
                                                    (onAction)="zoneSchedule.firstInterval.stopHour = zoneSchedule.changeHour(zoneSchedule.firstInterval.stopHour, 1)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_up.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                        <div class="change-interval__value font-bold font-18 bg-settings bg-settings--zone">
                                            {{ zoneSchedule.firstInterval.stopHour }}
                                        </div>
                                        <div class="change-interval__arrow-down cursor-pointer">
                                            <hold-wrapper
                                                    data-testid="stop-hour-down"
                                                    (onAction)="zoneSchedule.firstInterval.stopHour = zoneSchedule.changeHour(zoneSchedule.firstInterval.stopHour, -1)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_down.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                    </div>
                                    <p class="font-bold font-20">:</p>
                                    <div class="change-interval__stop-minute change-interval__item">
                                        <div class="change-interval__arrow-up cursor-pointer"
                                             *ngIf="zoneSchedule.firstInterval.stopHour !== '24'">
                                            <hold-wrapper
                                                    data-testid="stop-minute-up"
                                                    (onAction)="zoneSchedule.firstInterval.stopMinute = zoneSchedule.changeMinute(zoneSchedule.firstInterval.stopMinute, 15)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_up.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                        <div class="change-interval__value font-bold font-18 bg-settings bg-settings--zone">
                                            {{ zoneSchedule.firstInterval.stopMinute }}
                                        </div>
                                        <div class="change-interval__arrow-down cursor-pointer"
                                             *ngIf="zoneSchedule.firstInterval.stopHour !== '24'">
                                            <hold-wrapper
                                                    data-testid="stop-minute-down"
                                                    (onAction)="zoneSchedule.firstInterval.stopMinute = zoneSchedule.changeMinute(zoneSchedule.firstInterval.stopMinute, -15)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_down.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                    </div>
                                    <div class="change-interval__temperature color-light font-20 font-bold bg-error"
                                        data-testid="interval-temperature">
                                        {{ zoneSchedule.firstInterval.temp | format:7 }}
                                    </div>
                                </div>
                                <input class="change-interval__temp-range control__input-range cursor-pointer"
                                       data-testid="interval-slider"
                                       type="range"
                                       step="1"
                                       min="50"
                                       max="350"
                                       value="{{ zoneSchedule.firstInterval.temp }}"
                                       [(ngModel)]="zoneSchedule.firstInterval.temp"/>
                                <div class="change-interval__temp-add cursor-pointer">
                                    <hold-wrapper
                                            data-testid="decrease-icon"
                                            (onAction)="zoneSchedule.firstInterval.temp = zones.minusVal(zoneSchedule.firstInterval.temp)">
                                        <img ngSrc="/assets/img/icons/minus.svg"
                                             width="25" height="25" alt=""/>
                                    </hold-wrapper>
                                </div>
                                <div class="change-interval__temp-add cursor-pointer">
                                    <hold-wrapper
                                            data-testid="increase-icon"
                                            (onAction)="zoneSchedule.firstInterval.temp = zones.plusVal(zoneSchedule.firstInterval.temp)">
                                        <img ngSrc="/assets/img/icons/plus.svg"
                                             width="25" height="25" alt=""/>
                                    </hold-wrapper>
                                </div>
                                <div class="change-interval__group-btn">
                                    <button class="interval__button bg-cancel bg-cancel__button cursor-pointer"
                                            (click)="zoneSchedule.hideInterval('first')">
                                        <img class="interval__button-img zone-control__button-back"
                                             data-testid="back-icon"
                                             ngSrc="/assets/img/zone_icons/back.svg"
                                             width="40" height="40" alt=""/>
                                    </button>
                                    <button class="interval__button bg-ok bg-ok--accept cursor-pointer"
                                            (click)="zoneSchedule.saveInterval('first')">
                                        <img class="interval__button-img"
                                             data-testid="ok-icon"
                                             ngSrc="/assets/img/icons/ok.svg"
                                             width="40" height="40" alt=""/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="schedule__item schedule__item--second box-shadow"
                    data-testid="second-schedule">
                    <div class="schedule__week">
                        <div class="schedule__day cursor-pointer"
                             *ngFor="let day of zoneSchedule.schedule.p1Days; let idx = index"
                             [ngClass]="{ 'bg-style': day === '1',
                                'bg-default': day !== '1' }"
                             (click)="zoneSchedule.setDay(idx)">
                            <p class="color-light">{{ idx | shortDayName }}</p>
                        </div>
                    </div>

                    <div class="schedule__content">
                        <div class="schedule__set-temp">
                            <p class="schedule__temp-subtitle font-20 font-bold">
                                {{ subtitles.language === 'en' ? 'Setback temperature' : subtitle(760) }}
                            </p>
                            <p class="schedule__set-back-temp font-50 font-bold cursor-pointer"
                               data-testid="set-back-temp"
                               (click)="zoneSchedule.showHideSetTemp('second', zoneSchedule.schedule.p1SetbackTemp, 'show')">
                                {{ zoneSchedule.schedule.p1SetbackTemp | format:7 }}
                            </p>
                        </div>
                        <div class="interval">
                            <div class="interval__item"
                                 *ngFor="let interval of zoneSchedule.secondIntervals; let idx = index"
                                 [attr.data-testid]="'interval-' + idx">
                                <div class="interval__time bg-settings bg-settings--zone cursor-pointer"
                                     (click)="zoneSchedule.setInterval('second', idx)"
                                     [ngClass]="{ 'border-error interval__time--error': interval.wrongInterval }">
                                    <div class="interval__time-start">
                                        <p class="interval__value font-19 font-bold">
                                            {{ interval.start | format:13 }}
                                        </p>
                                    </div>
                                    <p class="interval__value font-18 font-bold">
                                        -</p>
                                    <div class="interval__time-stop">
                                        <p class="interval__value font-19 font-bold">
                                            {{ interval.stop | format:13 }}
                                        </p>
                                    </div>
                                </div>
                                <div class="interval__temp bg-error cursor-pointer"
                                     (click)="zoneSchedule.setInterval('second', idx)">
                                    <p class="interval__value font-19 font-bold color-light">
                                        {{ interval.temp | format:7 }}
                                    </p>
                                </div>
                                <div class="interval__delete-item"
                                     [attr.data-testid]="'delete-interval-' + idx"
                                     (click)="zoneSchedule.deleteInterval('second', idx)"
                                     (mouseenter)="secondDeleteHover = idx"
                                     (mouseleave)="secondDeleteHover = -1">
                                    <img class="interval__delete-img cursor-pointer bg-default"
                                         ngSrc="/assets/img/zone_icons/delete_interval.svg"
                                         [ngClass]="{ 'bg-cancel': secondDeleteHover === idx,
                                            'bg-default': secondDeleteHover !== idx }"
                                         width="25" height="25" alt=""/>
                                </div>
                            </div>

                            <div class="interval__add"
                                 data-testid="add-interval"
                                 *ngIf="zoneSchedule.secondIntervals.length < 3">
                                <img class="interval__add-img cursor-pointer"
                                     (mouseenter)="secondAddHover = true"
                                     (mouseleave)="secondAddHover = false"
                                     [ngClass]="{ 'bg-style': secondAddHover,
                                        'bg-default': !secondAddHover }"
                                     (click)="zoneSchedule.addInterval('second')"
                                     ngSrc="/assets/img/zone_icons/add_interval.svg"
                                     width="25" height="25" alt=""/>
                            </div>

                            <div class="interval__set-temp bg-light"
                                 data-testid="set-temp-control"
                                 *ngIf="zoneSchedule.showSecondSetTemp">
                                <p class="interval__set-temp-value font-38 font-bold"
                                   data-testid="set-temp">
                                    {{ zoneSchedule.secondSetTemp | format:7 }}
                                </p>
                                <input class="interval__set-temp-range control__input-range cursor-pointer"
                                       data-testid="set-temp-slider"
                                       type="range"
                                       step="1"
                                       min="50"
                                       max="350"
                                       value="{{ zoneSchedule.secondSetTemp }}"
                                       [(ngModel)]="zoneSchedule.secondSetTemp"/>
                                <p class="interval__set-temp-min">
                                    <span>{{ subtitle(1055) }}</span>
                                    <span>{{ 5 | format:6 }}</span>
                                </p>
                                <p class="interval__set-temp-max">
                                    <span>{{ subtitle(1937) }}</span>
                                    <span>{{ 35 | format:6 }}</span>
                                </p>
                                <div class="interval__set-temp-add cursor-pointer">
                                    <hold-wrapper
                                            data-testid="decrease-icon"
                                            (onAction)="zoneSchedule.secondSetTemp = zones.minusVal(zoneSchedule.secondSetTemp)">
                                        <img ngSrc="/assets/img/icons/minus.svg"
                                                      width="25" height="25" alt=""/>
                                    </hold-wrapper>
                                </div>
                                <div class="interval__set-temp-add cursor-pointer">
                                    <hold-wrapper
                                            data-testid="increase-icon"
                                            (onAction)="zoneSchedule.secondSetTemp = zones.plusVal(zoneSchedule.secondSetTemp)">
                                        <img ngSrc="/assets/img/icons/plus.svg"
                                             width="25" height="25" alt=""/>
                                    </hold-wrapper>
                                </div>
                                <div class="interval__group-btn">
                                    <button class="interval__button bg-cancel bg-cancel__button cursor-pointer"
                                            (click)="zoneSchedule.showHideSetTemp('second', zoneSchedule.secondSetTemp, 'hide')">
                                        <img class="interval__button-img zone-control__button-back"
                                             data-testid="back-icon"
                                             ngSrc="/assets/img/zone_icons/back.svg"
                                             width="25" height="25" alt=""/>
                                    </button>
                                    <button class="interval__button bg-ok bg-ok--accept cursor-pointer"
                                            (click)="zoneSchedule.showHideSetTemp('second', zoneSchedule.secondSetTemp, 'save')">
                                        <img class="interval__button-img"
                                             data-testid="ok-icon"
                                             ngSrc="/assets/img/icons/ok.svg"
                                             width="25" height="25" alt=""/>
                                    </button>
                                </div>
                            </div>

                            <div class="change-interval bg-light"
                                 data-testid="change-interval-control"
                                 *ngIf="zoneSchedule.showSecondInterval">
                                <div class="change-interval__interval">
                                    <div class="change-interval__start-hour change-interval__item">
                                        <div class="change-interval__arrow-up cursor-pointer">
                                            <hold-wrapper
                                                    data-testid="start-hour-up"
                                                    (onAction)="zoneSchedule.secondInterval.startHour = zoneSchedule.changeHour(zoneSchedule.secondInterval.startHour, 1)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_up.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                        <div class="change-interval__value font-bold font-18 bg-settings bg-settings--zone">
                                             {{ zoneSchedule.secondInterval.startHour }}
                                        </div>
                                        <div class="change-interval__arrow-down cursor-pointer">
                                            <hold-wrapper
                                                    data-testid="start-hour-down"
                                                    (onAction)="zoneSchedule.secondInterval.startHour = zoneSchedule.changeHour(zoneSchedule.secondInterval.startHour, -1)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_down.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                    </div>

                                    <p class="font-bold font-20">:</p>
                                    <div class="change-interval__start-minute change-interval__item">
                                        <div class="change-interval__arrow-up cursor-pointer"
                                             *ngIf="zoneSchedule.secondInterval.startHour !== '24'">
                                            <hold-wrapper
                                                    data-testid="start-minute-up"
                                                    (onAction)="zoneSchedule.secondInterval.startMinute = zoneSchedule.changeMinute(zoneSchedule.secondInterval.startMinute, 15)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_up.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                        <div class="change-interval__value font-bold font-18 bg-settings bg-settings--zone">
                                            {{ zoneSchedule.secondInterval.startMinute }}
                                        </div>
                                        <div class="change-interval__arrow-down cursor-pointer"
                                             *ngIf="zoneSchedule.secondInterval.startHour !== '24'">
                                            <hold-wrapper
                                                    data-testid="start-minute-down"
                                                    (onAction)="zoneSchedule.secondInterval.startMinute = zoneSchedule.changeMinute(zoneSchedule.secondInterval.startMinute, -15)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_down.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                    </div>

                                    <p class="font-bold font-20">-</p>
                                    <div class="change-interval__stop-hour change-interval__item">
                                        <div class="change-interval__arrow-up cursor-pointer">
                                            <hold-wrapper
                                                    (onAction)="zoneSchedule.secondInterval.stopHour = zoneSchedule.changeHour(zoneSchedule.secondInterval.stopHour, 1)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_up.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                        <div class="change-interval__value font-bold font-18 bg-settings bg-settings--zone">
                                            {{ zoneSchedule.secondInterval.stopHour }}
                                        </div>
                                        <div class="change-interval__arrow-down cursor-pointer">
                                            <hold-wrapper
                                                    data-testid="stop-hour-down"
                                                    (onAction)="zoneSchedule.secondInterval.stopHour = zoneSchedule.changeHour(zoneSchedule.secondInterval.stopHour, -1)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_down.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                    </div>

                                    <p class="font-bold font-20">:</p>
                                    <div class="change-interval__stop-minute change-interval__item">
                                        <div class="change-interval__arrow-up cursor-pointer"
                                             *ngIf="zoneSchedule.secondInterval.stopHour !== '24'">
                                            <hold-wrapper
                                                    data-testid="stop-minute-up"
                                                    (onAction)="zoneSchedule.secondInterval.stopMinute = zoneSchedule.changeMinute(zoneSchedule.secondInterval.stopMinute, 15)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_up.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                        <div class="change-interval__value font-bold font-18 bg-settings bg-settings--zone">
                                            {{ zoneSchedule.secondInterval.stopMinute }}
                                        </div>
                                        <div class="change-interval__arrow-down cursor-pointer"
                                             *ngIf="zoneSchedule.secondInterval.stopHour !== '24'">
                                            <hold-wrapper
                                                    data-testid="stop-minute-down"
                                                    (onAction)="zoneSchedule.secondInterval.stopMinute = zoneSchedule.changeMinute(zoneSchedule.secondInterval.stopMinute, -15)">
                                                <img class="change-interval__arrow"
                                                     ngSrc="/assets/img/zone_icons/arrow_down.svg"
                                                     width="25" height="25"
                                                     alt=""/>
                                            </hold-wrapper>
                                        </div>
                                    </div>
                                    <div class="change-interval__temperature bg-error color-light font-18 font-bold">
                                        {{ zoneSchedule.secondInterval.temp | format:7 }}
                                    </div>
                                </div>

                                <input class="change-interval__temp-range control__input-range cursor-pointer"
                                       data-testid="interval-slider"
                                       type="range"
                                       step="1"
                                       min="50"
                                       max="350"
                                       value="{{zoneSchedule.secondInterval.temp}}"
                                       [(ngModel)]="zoneSchedule.secondInterval.temp"/>
                                <div class="change-interval__temp-add cursor-pointer">
                                    <hold-wrapper
                                            (onAction)="zoneSchedule.secondInterval.temp = zones.minusVal(zoneSchedule.secondInterval.temp)">
                                        <img ngSrc="/assets/img/icons/minus.svg"
                                             width="25" height="25" alt=""/>
                                    </hold-wrapper>
                                </div>
                                <div class="change-interval__temp-add cursor-pointer">
                                    <hold-wrapper
                                            (onAction)="zoneSchedule.secondInterval.temp = zones.plusVal(zoneSchedule.secondInterval.temp)">
                                        <img ngSrc="/assets/img/icons/plus.svg"
                                             width="25" height="25" alt=""/>
                                    </hold-wrapper>
                                </div>

                                <div class="change-interval__group-btn">
                                    <button class="interval__button bg-cancel bg-cancel__button cursor-pointer"
                                            (click)="zoneSchedule.hideInterval('second')">
                                        <img class="interval__button-img zone-control__button-back"
                                             data-testid="back-icon"
                                             ngSrc="/assets/img/zone_icons/back.svg"
                                             width="25" height="25" alt=""/>
                                    </button>
                                    <button class="interval__button bg-ok bg-ok--accept cursor-pointer"
                                            (click)="zoneSchedule.saveInterval('second')">
                                        <img class="interval__button-img"
                                             data-testid="ok-icon"
                                             ngSrc="/assets/img/icons/ok.svg"
                                             width="25" height="25" alt=""/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="control__group-btn schedule__buttons">
                <button class="control__button bg-cancel bg-cancel__button"
                        data-testid="back-button"
                        (click)="zones.goBack()">
                    <img class="control__button-img zone-control__button-back"
                         ngSrc="/assets/img/zone_icons/back.svg"
                         width="40" height="40" alt=""/>
                </button>
                <button class="control__button bg-ok bg-ok--accept"
                        *ngIf="!zoneSchedule.isSendingSchedule"
                        data-testid="send-button"
                        (click)="zoneSchedule.checkSchedule()">
                    <img class="control__button-img"
                         ngSrc="/assets/img/icons/ok.svg"
                         width="40" height="40" alt=""/>
                </button>
                <div class="control__button bg-ok bg-ok--accept center-content"
                     *ngIf="zoneSchedule.isSendingSchedule">
                    <loader></loader>
                </div>
            </div>
        </div>
    </div>
</div>
